<template>
  <el-carousel v-if="content.length >=1" height="400px" :interval="3000" initial-index="0" arrow="always">
    <el-carousel-item v-for="(item,index) in content" :key="'top-slider'+index">
      <a :href="item.link"><el-image style="width:100%;height: 400px" :src="item.image" :fit="item.fit"></el-image></a>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import api from "../api/api"

export default {
  name: "Slider",
  data() {
    return {
      content: []
    }
  },
  async mounted() {
    let json = await api.common.slider()
    this.content = json.data;
  }
}
</script>

<style scoped>

</style>